module.exports = __webpack_public_path__ + "static/media/valor3.90fb8a1c.png";